"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgHelpFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-7.948 1.082C15.24 12.293 16 11.28 16 10c.003-1.956-1.44-3.62-3.401-3.948-1.956-.326-3.874.77-4.54 2.608a1 1 0 0 0 1.881.68c.334-.922 1.318-1.484 2.33-1.315 1.006.168 1.732 1.005 1.73 1.973 0 .472-.367.96-1.057 1.42a5.993 5.993 0 0 1-1.264.633 1 1 0 0 0-.684.949v1a1 1 0 1 0 2 0v-.325a7.98 7.98 0 0 0 1.057-.593ZM12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgHelpFilled);
//# sourceMappingURL=SvgHelpFilled.js.map